import { createContext, useEffect, useState } from "react";
import axiosClient from "../api/api";

export const UserContext = createContext({
  user: null,
});

export default function UserStore({ children }) {
  const [user, setUser] = useState(null);

  const fetchUser = async () => {
    const response = await axiosClient.get("/auth/me");
    if (response.status === 200) {
      setUser(response.data);
    }
  };

  useEffect(() => {
    fetchUser();
  }, []);

  return (
    <UserContext.Provider value={{ user, fetchUser }}>
      {children}
    </UserContext.Provider>
  );
}
